import { c as _c } from "react/compiler-runtime";
/**
 * @see https://github.com/mantinedev/mantine/blob/master/packages/@mantine/hooks/src/use-debounced-callback/use-debounced-callback.ts
 */

import * as React from "react";
import { useCallbackRef } from "./useCallbackRef";
export function useDebouncedCallback(callback, delay) {
  const $ = _c(5);
  const handleCallback = useCallbackRef(callback);
  const debounceTimerRef = React.useRef(0);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => () => window.clearTimeout(debounceTimerRef.current);
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  React.useEffect(t0, t1);
  let t2;
  if ($[2] !== delay || $[3] !== handleCallback) {
    t2 = (...t3) => {
      const args = t3;
      window.clearTimeout(debounceTimerRef.current);
      debounceTimerRef.current = window.setTimeout(() => handleCallback(...args), delay);
    };
    $[2] = delay;
    $[3] = handleCallback;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const setValue = t2;
  return setValue;
}